import React from "react"
import { PlayIcon } from "@radix-ui/react-icons"
import { useState } from "react"
import { IconButton, ImageUploadButton } from "./ui/button"
import Shortcuts from "./Shortcuts"
import { useImage } from "../hooks/useImage"

import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover"
import PromptInput from "./PromptInput"
import { RotateCw, Image, Upload, Trash2 } from "lucide-react"
import FileManager from "./FileManager"
import { getMediaFile } from "../lib/api"
import { useStore } from "../lib/states"
import SettingsDialog from "./Settings"
import { cn, fileToImage } from "../lib/utils"
import { useToast } from "./ui/use-toast"
import { UPSCALE_MODEL, MAGIC_FILL_MODEL, REMOVE_OBJECTS_MODEL } from '../../../constants/model';

const Header = ({choseModel, userData, firebase, isMobile, removeImageFromEditor}) => {
  const [
    file,
    customMask,
    isInpainting,
    serverConfig,
    runMannually,
    enableUploadMask,
    model,
    setFile,
    setCustomFile,
    runInpainting,
    showPrevMask,
    hidePrevMask,
    imageHeight,
    imageWidth,
    setImageSize,
    updateEditorState,
    updateAppState
  ] = useStore((state) => [
    state.file,
    state.customMask,
    state.isInpainting,
    state.serverConfig,
    state.runMannually(),
    state.settings.enableUploadMask,
    state.settings.model,
    state.setFile,
    state.setCustomFile,
    state.runInpainting,
    state.showPrevMask,
    state.hidePrevMask,
    state.imageHeight,
    state.imageWidth,
    state.setImageSize,
    state.updateEditorState,
    state.updateAppState
  ])

  const { toast } = useToast()
  const [maskImage, maskImageLoaded] = useImage(customMask)
  const [openMaskPopover, setOpenMaskPopover] = useState(false)

  const handleRerunLastMask = () => {
    runInpainting()
  }

  const onRerunMouseEnter = () => {
    showPrevMask()
  }

  const onRerunMouseLeave = () => {
    hidePrevMask()
  }

  const addImage = (file: File) => {
    setFile(file)
    updateAppState({
      file
    });
  }

  const removeImage = () => {
    setFile(null);
    updateAppState({
      imageHeight: 0,
      imageWidth: 0,
    });
    updateEditorState({ renders: [], lineGroups: [], lastLineGroup: [], curLineGroup: [], extraMasks: [], prevExtraMasks: [], temporaryMasks: [], redoRenders: [], redoCurLines: [], redoLineGroups: []});
  }

  return (
    <header className="h-[60px] px-4 py-4 absolute top-[0] flex justify-between items-center w-full z-20 border-b backdrop-filter backdrop-blur-md bg-background/70 mobile-image-size">
      <div className="flex items-center gap-1">
        {/* {serverConfig.enableFileManager ? (
          <FileManager
            photoWidth={512}
            onPhotoClick={async (tab: string, filename: string) => {
              try {
                const newFile = await getMediaFile(tab, filename)
                setFile(newFile)
              } catch (e: any) {
                toast({
                  variant: "destructive",
                  description: e.message ? e.message : e.toString(),
                })
                return
              }
            }}
          />
        ) : (
          <></>
        )} */}
        <ImageUploadButton
          disabled={isInpainting}
          tooltip="Upload image"
          onFileUpload={(file) => {
            setFile(file)
          }}
        >
          <Image />
        </ImageUploadButton>

        <IconButton
          disabled={isInpainting || !file}
          tooltip=""
          onClick={removeImage}
        >
          <Trash2 />
        </IconButton>

        {choseModel === REMOVE_OBJECTS_MODEL && <p className="bold">Magic eraser</p>}
        {choseModel === UPSCALE_MODEL && <p className="bold">Magic upscaler</p>}

        <div
          className={cn([
            "flex items-center gap-1",
            file && enableUploadMask ? "visible" : "hidden",
          ])}
        >
          <ImageUploadButton
            disabled={isInpainting}
            tooltip="Upload custom mask"
            onFileUpload={async (file) => {
              let newCustomMask: HTMLImageElement | null = null
              try {
                newCustomMask = await fileToImage(file)
              } catch (e: any) {
                toast({
                  variant: "destructive",
                  description: e.message ? e.message : e.toString(),
                })
                return
              }
              if (
                newCustomMask.naturalHeight !== imageHeight ||
                newCustomMask.naturalWidth !== imageWidth
              ) {
                toast({
                  variant: "destructive",
                  description: `The size of the mask must same as image: ${imageWidth}x${imageHeight}`,
                })
                return
              }

              setCustomFile(file)
              if (!runMannually) {
                runInpainting()
              }
            }}
          >
            <Upload />
          </ImageUploadButton>

          {customMask ? (
            <Popover open={openMaskPopover}>
              <PopoverTrigger
                className="btn-primary side-panel-trigger"
                onMouseEnter={() => setOpenMaskPopover(true)}
                onMouseLeave={() => setOpenMaskPopover(false)}
                style={{
                  visibility: customMask ? "visible" : "hidden",
                  outline: "none",
                }}
                onClick={() => {
                  if (customMask) {
                  }
                }}
              >
                <IconButton tooltip="Run custom mask">
                  <PlayIcon />
                </IconButton>
              </PopoverTrigger>
              <PopoverContent>
                {maskImageLoaded ? (
                  <img src={maskImage.src} alt="Custom mask" />
                ) : (
                  <></>
                )}
              </PopoverContent>
            </Popover>
          ) : (
            <></>
          )}
        </div>

        {/* {file ? (
          <IconButton
            disabled={isInpainting}
            tooltip="Rerun previous mask"
            onClick={handleRerunLastMask}
            onMouseEnter={onRerunMouseEnter}
            onMouseLeave={onRerunMouseLeave}
          >
            <RotateCw />
          </IconButton>
        ) : (
          <></>
        )} */}
      </div>

      {choseModel === MAGIC_FILL_MODEL ? <PromptInput userData={userData} firebase={firebase} isMobile={isMobile}/> : <></>}

      <div className="flex gap-1">
        {!isMobile && <Shortcuts />}
        {/* {serverConfig.disableModelSwitch ? <></> : <SettingsDialog />} */}
      </div>
    </header>
  )
}

export default Header
